import React from 'react';
import { Layout, Space } from 'antd';
import { TwitterOutlined } from '@ant-design/icons';
import { SiTelegram } from 'react-icons/si';
import { useTranslation } from 'react-i18next';

const { Footer: AntFooter } = Layout;

const Footer = () => {
  const { t } = useTranslation();

  return (
    <AntFooter style={{
      textAlign: 'center',
      backgroundColor: '#fff',
      borderTop: '1px solid #e8e8e8',
      padding: '24px 50px'
    }}>
      <div style={{ marginBottom: '16px' }}>
        <Space size="large" align="center">
          <a
            href="https://t.me/kaskeeper_official"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#00c4b4',
              fontSize: '32px',
              transition: 'color 0.3s',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '32px',
              height: '32px'
            }}
            onMouseEnter={(e) => e.target.style.color = '#009688'}
            onMouseLeave={(e) => e.target.style.color = '#00c4b4'}
          >
            <SiTelegram />
          </a>
          <a
            href="https://x.com/Kaspa_KEF"
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#00c4b4',
              fontSize: '32px',
              transition: 'color 0.3s',
              display: 'inline-flex',
              alignItems: 'center',
              justifyContent: 'center',
              width: '32px',
              height: '32px'
            }}
            onMouseEnter={(e) => e.target.style.color = '#009688'}
            onMouseLeave={(e) => e.target.style.color = '#00c4b4'}
          >
            <TwitterOutlined />
          </a>
        </Space>
      </div>
      <div style={{ color: '#666' }}>
        {t('footer.copyright')}
      </div>
    </AntFooter>
  );
};

export default Footer;